<template>
    <b-button v-on="$listeners" type="submit" class="form-button">{{title || 'Salvar'}}</b-button>
</template>

<script>
export default {
    props: ['title']
}
</script>

<style scoped>
    .form-button {
        width: 80px;
        background-color: #163247 !important;
        border-color: #042035 !important;        
        float: right;
    }

    .form-button:hover {
        background-color: #042035 !important;
        border-color: #042035 !important;
        font-weight: bold;
    }    
</style>



// WEBPACK FOOTER //
// src/components/shared/FormButton.vue